
const WithdrawalsIcon = () => {
  return (
    (<svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="WithdrawalsIcon">
      <path
        d="M9.00008 17.3333C4.39758 17.3333 0.666748 13.6025 0.666748 9C0.666748 4.3975 4.39758 0.666666 9.00008 0.666666C10.294 0.665694 11.5702 0.966477 12.7275 1.54512C13.8848 2.12376 14.8912 2.96431 15.6667 4H13.4084C12.4461 3.15147 11.2594 2.59863 9.99068 2.40783C8.72196 2.21703 7.42514 2.39638 6.25582 2.92434C5.08651 3.45231 4.09437 4.30647 3.39847 5.38432C2.70257 6.46218 2.33247 7.71794 2.33258 9.00092C2.33269 10.2839 2.703 11.5396 3.39908 12.6173C4.09515 13.6951 5.08743 14.5491 6.25683 15.0768C7.42624 15.6046 8.72309 15.7837 9.99178 15.5927C11.2605 15.4017 12.4471 14.8487 13.4093 14H15.6676C14.8919 15.0358 13.8854 15.8764 12.728 16.4551C11.5705 17.0337 10.2941 17.3344 9.00008 17.3333ZM14.8334 12.3333V9.83333H8.16675V8.16667H14.8334V5.66667L19.0001 9L14.8334 12.3333Z"
        fill="currentColor"
        stroke="var(--main-bg-surface)"
        strokeWidth="0.4"
      />
    </svg>)
  );
};

export default WithdrawalsIcon;
